import React from 'react';

import MobileProductListHeaderSkeleton from "@src/componentsNew/Skeleton/mobile/components/MobileProductListHeaderSkeleton";
import MobileProductListSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileProductListSkeleton';

interface IProps {
  type: 'normal' | 'category' | 'brand';
}

const MobileProductListPageSkeleton = ({ type }: IProps) => {
  return (
    <div>
      <MobileProductListHeaderSkeleton type={type} />
      <MobileProductListSkeleton type='vertical' />
    </div>
  );
};

export default MobileProductListPageSkeleton;
